
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/health-score",
      function () {
        return require("private-next-pages/health-score.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/health-score"])
      });
    }
  